import axios from 'axios'
import https from 'https'

import { createStore, FetchMode } from '@thg-commerce/enterprise-cache'

const EXPERIMENTATION_SERVICE_BASE_URL =
  process.env.EXPERIMENTATION_SERVICE_BASE_URL ||
  'https://experimentation-management-service.gslb.io.thehut.local/ExperimentationManagementService'
const EXPERIMENTATION_SERVICE_PATH_DETAILS = '/details/clientref'

export interface Experiment {
  name: string
  startDate: number
  endDate: number
}

const httpsAgent = new https.Agent({
  rejectUnauthorized: false,
  keepAlive: true,
})
const experimentStore = createStore<{ domain: string }, Experiment[]>({
  key: (args) => `experiments-${args.domain}`,
  ttlSeconds: 60,
  staleSeconds: 86400,
  fetchMode: FetchMode.ALWAYS_BACKGROUND,
  lookup: async (args) => {
    const experiments = await axios.get<
      { name: string; startDate: number; endDate: number; live: boolean }[]
    >(
      `${EXPERIMENTATION_SERVICE_BASE_URL}${EXPERIMENTATION_SERVICE_PATH_DETAILS}/elysium-${args.domain}`,
      { httpsAgent },
    )
    return experiments.data.reduce<any[]>((accumulator, experiment) => {
      if (!experiment.live) {
        return accumulator
      }
      accumulator.push({
        name: experiment.name,
        startDate: experiment.startDate,
        endDate: experiment.endDate,
      })

      return accumulator
    }, [])
  },
})

export const experimentsVary = async (request: {
  experiments: string[]
  domain: string
}) => {
  const liveExperiments = await experimentStore.get({ domain: request.domain })
  if (!liveExperiments) {
    return []
  }

  const now = new Date().getTime()

  const matchingExperiments = liveExperiments.reduce(
    (accumulator: string[], experiment) => {
      if (!request.experiments.includes(experiment.name)) {
        return accumulator
      }
      if (experiment.startDate < now && experiment.endDate > now) {
        accumulator.push(experiment.name)
      }
      return accumulator
    },
    [],
  )

  return matchingExperiments.length > 0 ? ['X-Experiments'] : []
}
